import _ from "underscore";

import api from "@/helpers/api";
import auth from "@/helpers/auth";

const apiVersion = 'v1';
const source = 'user';

export default {
  state: {
    signedIn: false,
    currentUser: null
  },

  mutations: {
    setCurrentUser(state, data) {
      const user = data.data.attributes;
      user.teams = [];

      _.each(data.included, (inc) => {
        if (inc.type === "teams") user.teams.push(inc.attributes);
      });

      state.currentUser = user;
    },

    setSignedIn(state, signedIn) {
      state.signedIn = signedIn;
      if (!signedIn) state.currentUser = null;
    }
  },

  actions: {
    fetchCurrentUser({ commit }) {
      return api
        .instance()
        .get(`${apiVersion}/${source}`)
        .then((resp) => {
          commit("setCurrentUser", resp.data);
        })
        .catch((err) => {
          console.error("error loading current user", err);
          this.signOut();
        });
    },

    setInitialSignInState({ commit, dispatch }) {
      const signedIn = auth.signedIn();
      commit("setSignedIn", signedIn);
      if (signedIn) dispatch("loadInitialData");
    },

    signIn({ commit, dispatch }, token) {
      auth.signIn(token);
      commit("setSignedIn", true);
      dispatch("loadInitialData");
    },

    signOut({ commit }) {
      auth.signOut();
      commit("setSignedIn", false);
    },

    loadInitialData({ dispatch }) {
      dispatch("fetchCurrentUser");
      dispatch("fetchCurrentTeam");
      dispatch("fetchCategories");
      dispatch("fetchQueries");
      dispatch("fetchDealerships");
      dispatch("fetchIntegrations");
      dispatch("fetchClientApplications");
      dispatch("fetchWrongCfgEvents");
    }
  },

  getters: {
    signedIn: (state) => state.signedIn,
    currentUser: (state) => state.currentUser,
    isAdmin: (state) => {
      return state.currentUser && state.currentUser.name === "Admin";
    }
  }
};
